/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { AgentConsoleLayoutSettings } from "../components/AgentConsoleSettings/AgentConsoleLayoutSettings";
import { MetricsConfigurationSettings } from "../components/AgentConsoleSettings/MetricsConfigurationSettings";
import { ContentLayout, PanelContainer } from "../../../components/Common";
import PageTabs from "../../../components/Common/PageTabs";

const AgentConsoleSettingsPage = () => {
	return (
		<ContentLayout>
			<PanelContainer spacing={0} className="w-100">
				<PageTabs
					tabs={[
						{
							id: "layout_configuration",
							label: "Layout Configuration",
							component: <AgentConsoleLayoutSettings />,
							default: true,
						},
						{
							id: "metric_configuration",
							label: "Metrics Configuration",
							component: <MetricsConfigurationSettings />,
							default: false,
						},
					]}
					requireConfirmOnChange
					selectedTabInQueryString={true}
				/>
			</PanelContainer>
		</ContentLayout>
	);
};

export default AgentConsoleSettingsPage;
